import { CKButton } from '@clearkit/react';
import Typography from '@material-ui/core/Typography';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import { Subscribe } from 'unstated';

import Constants from '~/components/Constants';
import Switch from '~/components/SwitchWithLabel';
import TextField from '~/components/TextField';
import ConnectorsContainer from '~/containers/Connectors';
import UserContainer from '~/containers/User';
import { testFormHubspotConnection } from '~/lib/client';

import ContactForm from './ContactForm';
import styles from './SharedSettings.style';
import Sidebar, {
  SidebarHeader,
  SidebarTitle,
  SidebarTypography,
} from './Sidebar';

class HubspotSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: this.props.form,
      connectionStatus: null,
      hubspotKeyError: false,
    };
  }

  UNSAFE_componentWillReceiveProps({ form }) {
    if (form) {
      this.setState({ form });
    }
  }

  hasConnector = () => {
    return !isEmpty(this.getConnector());
  };

  getConnector = () => {
    const connector = Object.entries(
      this.props.connectorsContainer.state.connectors,
    ).find((serviceConnector) => {
      const [service, _] = serviceConnector;
      return service == 'hubspot';
    });
    return connector && connector[1];
  };

  setConnectionStatus = (connectionStatus) => {
    this.setState({ connectionStatus });
  };

  testConnection = () => {
    const { form } = this.props;
    const { testConnectionPending } = this.state;

    if (testConnectionPending) return;

    this.setState({ testConnectionPending: true });

    testFormHubspotConnection(form.id)
      .then(this.setConnectionStatus)
      .then(() => {
        this.setState({ testConnectionPending: false });
      });
  };

  onChange = (attr, event) => {
    let form = Object.assign({}, this.state.form);
    form[attr] = event.target.value;
    this.setState({ form });
  };

  onBlur = () => {
    const { form } = this.state;

    if (this.validate(form)) {
      this.props.onUpdateForm(form);
    }
  };

  onToggle = (attr, event) => {
    let form = Object.assign({}, this.state.form);
    form[attr] = event.target.checked;

    if (this.validate(form)) {
      this.props.onUpdateForm(form);
    }
  };

  validateWithKey = (form) => {
    this.setState({ hubspotKeyError: false });

    if (!form.hubspot_enabled) return true;

    if (!form.hubspot_key) {
      this.setState({ hubspotKeyError: true });
      return false;
    }
  };

  validate = (form) => {
    if (!this.hasConnector()) {
      return this.validateWithKey(form);
    } else {
      return true;
    }
  };

  renderConnectionStatus() {
    const { classes } = this.props;
    const { connectionStatus } = this.state;

    if (!connectionStatus) return;

    let message = connectionStatus.message;

    if (connectionStatus.success) {
      message = message || 'Connection succeed';
    }

    return (
      <Typography
        type="body1"
        className={classnames(classes.p, {
          [classes.success]: connectionStatus.success,
          [classes.error]: !connectionStatus.success,
        })}>
        {message}
      </Typography>
    );
  }

  renderConnectorForm = () => {
    const { classes } = this.props;
    const { form, testConnectionPending } = this.state;
    const connector = this.getConnector();

    return (
      <Sidebar>
        <SidebarHeader>
          <SidebarTitle>HubSpot settings</SidebarTitle>

          <Switch
            label="Enabled"
            checked={form.hubspot_enabled}
            onChange={this.onToggle.bind(this, 'hubspot_enabled')}
          />
        </SidebarHeader>

        <SidebarTypography>
          Create a new lead in HubSpot every time a form is submitted. For more
          information and help with setup, please see our{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://help.clearbit.com/hc/en-us/articles/360006052034-Integrating-with-Hubspot">
            configuration guide
          </a>
          .
        </SidebarTypography>

        {this.hasConnector() ? (
          <SidebarTypography>
            Your HubSpot account <span>{connector.name}</span> is connected
            using your global OAuth connection. You can change this connection{' '}
            <Link to="/settings/configuration/hubspot">in your settings.</Link>
          </SidebarTypography>
        ) : (
          <div className={classes.input}>
            <TextField
              fullWidth
              autoComplete="off"
              name="HubSpot API Key"
              label="HubSpot API Key"
              type="text"
              required
              error={this.state.hubspotKeyError}
              value={form.hubspot_key || ''}
              onChange={this.onChange.bind(this, 'hubspot_key')}
              onBlur={this.onBlur}
            />
          </div>
        )}

        <div className={classes.footer}>
          <div className={classes.testConnection}>
            <CKButton
              disabled={testConnectionPending}
              variant="bold"
              variantColor="blue"
              onClick={this.testConnection}>
              Test connection
            </CKButton>
            {this.renderConnectionStatus()}
          </div>
        </div>
      </Sidebar>
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <Subscribe to={[UserContainer]}>
        {(container) => (
          <div className={classes.root}>
            {container.shouldShowFormConnectors() && (
              <ContactForm
                title="HubSpot settings"
                body="Access to premium integrations is available on Enterprise plans. Please contact our success team to get started!"
                form_id={Constants.CONTACT_SALES_FORM_ID}
              />
            )}
          </div>
        )}
      </Subscribe>
    );
  }
}

HubspotSettings.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  onUpdateForm: PropTypes.func.isRequired,
};

const SubscribedHubspotSettings = ({ ...props }) => {
  return (
    <Subscribe to={[ConnectorsContainer]}>
      {(connectorsContainer) => (
        <HubspotSettings connectorsContainer={connectorsContainer} {...props} />
      )}
    </Subscribe>
  );
};

export default withStyles(styles)(SubscribedHubspotSettings);
